<template>
    <div class="configurator__view">
        <div class="configurator__view__mobile">
            <div class="title" v-if="hasProduct">{{ $store.state.product.name }}</div>
        </div>

        <!-- Viewer Object -->
        <div class="configurator__view__object" id="configurator-viewer">
        </div>

        <!-- Configurator Controls -->
        <div class="configurator__view__controls">
            <zoom-controls v-if="hasProduct"></zoom-controls>
            <cart-controls v-if="hasProduct" @clicked:cart="$emit('clicked:cart')"></cart-controls>
            <progress-bar type="mobile"></progress-bar>
        </div>
    </div>
</template>

<script>
    import ZoomControls           from "../ZoomControls"
    import CartControls           from "../CartControls"
    import {mapGetters, mapState} from "vuex"

    export default {
        name:       "ExpiviViewer",
        components: {CartControls, ZoomControls},
        data:       function () {
            return {
                token: process.env.VUE_APP_EXPIVI_TOKEN,
            }
        },
        computed:   {
            ...mapGetters(['hasProduct']),
            ...mapState(['product'])
        },
        watch:      {
            /**
             * Watch for changes of the product. If we have a product, get the expivi ID and the preconfiguration
             * from the WooCommerce Product. Initialize the viewer withe the received values.
             * @param hasProduct
             */
            hasProduct: function (hasProduct) {
                if (hasProduct === true) {
                    let expiviID  = null
                    let preConfig = null

                    let filteredExpivId = this.product.meta_data.filter(meta => {
                        return meta.key === 'expivi_id'
                    })

                    let filteredPreConfig = this.product.meta_data.filter(meta => {
                        return meta.key === 'pre_configuration' && meta.value != null && meta.value !== ''
                    })

                    if (filteredExpivId.length > 0) {
                        expiviID = filteredExpivId[0].value
                    }

                    if (filteredPreConfig.length > 0) {
                        preConfig = JSON.parse(filteredPreConfig[0].value)
                    }

                    //window.expivi._create(this.token, expiviID, '#configurator-viewer', false, null, null, null, preConfig)
                    window.expivi._create(this.token, expiviID, '#configurator-viewer', {
                        cameraDropDownVisible: false,
                        defaultOptions:        null,
                        defaultMaterials:      null,
                        defaultApplied:        null,
                        configuredProduct:     null,
                        temporaryProductId:    null,
                        show360Indicator:      true,
                        showProgress:          false,
                        preset:                preConfig
                    })
                }
            }
        }
    }
</script>
